import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  useEffect,
} from "react";
import authService from "../service/authService";
import { jwtDecode } from "jwt-decode";

interface AuthContextProps {
  isAuthenticated: boolean;
  user: { name: string; username: string } | null;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    authService.isAuthenticated()
  );
  const [user, setUser] = useState<{ name: string; username: string } | null>(
    null
  );

  useEffect(() => {
    const token = authService.getToken();

    if (token) {
      console.log("Autenticated");
      const decoded: any = jwtDecode(token);
      setUser({ name: decoded.name, username: decoded.username });
    } else {
      console.log("Not Autenticated " + isAuthenticated);

      setIsAuthenticated(false);
    }
  }, [isAuthenticated]);

  const login = async (username: string, password: string) => {
    try {
      const userInfo = await authService.login(username, password);
      setIsAuthenticated(true);
      setUser({ name: userInfo.name, username: userInfo.username });
      console.log(user?.name);
    } catch (error) {
      setIsAuthenticated(false);
      setUser(null);
      throw error;
    }
  };

  const logout = () => {
    authService.logout();
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
